import UserCertificateList from './UserCertificateList.js';

export default UserCertificateList;